<template>
  <div class="page">
    <div class="page_title">
      产品编辑
    </div>
    <form class="form">
      <div class="form_row">
        <div class="label">产品名称</div>
        <input class="input" placeholder="请填写产品名称">
      </div>
      <div class="form_row">
        <div class="label">价格</div>
        <input class="input" placeholder="产品价格">
      </div>
      <div class="form_row">
        <div class="label">单位</div>
        <input class="input" placeholder="产品单位">
      </div>
      <div class="form_row">
        <div class="label">描述</div>
        <input class="input" placeholder="产品描述">
      </div>
      <div class="form_row">
        <div class="label_imgload">图片</div>
        <div class="imgUpload">
          <van-uploader v-model="fileList" multiple />
        </div>
      </div>

      <div class="button_container">
        <a href="javascript:" role="button" class="weui-btn weui-btn_primary" @click="submitProduct">确认</a>
      </div>

    </form>
  </div>
</template>

<script>
export default {
  name: "modify_product",
  data() {
    return {
      productInfo: {
        name: '',
        price: '',
        unit: '',
        discription: '',
        img: ''
      },
      labelPosition: 'right',
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      fileList: []
    }
  },
  methods: {
    // 确认提交
    submitProduct(){
      console.log('确认提交');
    },
  }
}
</script>

<style src="../css/modify_product.css" scoped>

</style>



// WEBPACK FOOTER //
// src/views/modify_product.vue